import React from 'react';

import * as SC from '@/components/common/chips/Chips.style';
import type { IconType } from '@/components/common/Icon';

export type ChipsContextType = {
  targetId: string;
  onClick?: () => void;
};

const ChipsContext = React.createContext<ChipsContextType | null>(null);

export const useChips = () => {
  const context = React.useContext(ChipsContext);
  if (!context) {
    throw new Error('useChips cannot be called outside the chips');
  }
  return context;
};

export type ChipsProps = {
  targetId: string;
  children: React.ReactNode;
  onClick?: () => void;
};

const Chips = ({ targetId, children, onClick }: ChipsProps) => {
  const value = React.useMemo(
    () => ({
      targetId,
      onClick,
    }),
    [targetId, onClick],
  );

  return <ChipsContext.Provider value={value!}>{children}</ChipsContext.Provider>;
};

type IconProps = {
  children?: React.ReactNode;
  icon?: IconType;
  size?: string;
  onClick?: () => void;
};

const Icon = ({ children, icon, size, onClick }: IconProps) => {
  return (
    <SC.IconBox size={size} onClick={onClick}>
      {children && children}
      {icon && <Icon icon={icon} size={size} />}
    </SC.IconBox>
  );
};

type LabelProps = {
  className?: string;
  label?: string;
  children?: React.ReactNode;
};

const Label = ({ children, className, label }: LabelProps) => {
  const { targetId } = useChips();

  return (
    <label htmlFor={targetId} className={className}>
      {label && <SC.LabelText>{label}</SC.LabelText>}
      {children && children}
    </label>
  );
};

Chips.Icon = Icon;
/**
 * @param className
 * @param children children 또는 label 택1
 * @param Label children 또는 label 택1
 */
Chips.Label = Label;

export default Chips;
